import React, { useState } from 'react'
import { noop } from '@neo/ramda-extra'
import { Formik } from 'formik'
import { Modal as ModalBase } from '@vega/components'
import { PropertyDetails } from './PropertyDetails'
import { PropertySearch } from './PropertySearch'
import { SavedPropertyQuestions } from './SavedPropertyQuestions'
import { styled, s } from '@vega/styled'

const Container = styled.div(
  s('bg-green-50', { height: '100vh', width: '100vw', overflowY: 'auto' })
)

function SavePropertyModal({ isOpen, onClose }) {
  const [currentPage, setCurrentPage] = useState('propertySearch')

  const onModalClose = () => {
    onClose()
    setCurrentPage('propertySearch')
  }

  return (
    <ModalBase isOpen={isOpen} onClose={onModalClose}>
      <Formik
        enableReinitialize
        initialValues={{
          search: '',
          hasMadeOffer: undefined,
          hasWonOffer: undefined,
          isIntendedToSubmit: undefined,
        }}
        onSubmit={noop}
      >
        <Container>
          {currentPage === 'propertySearch' && (
            <PropertySearch onClose={onModalClose} setCurrentPage={setCurrentPage} />
          )}
          {currentPage === 'propertyDetails' && (
            <PropertyDetails onClose={onModalClose} setCurrentPage={setCurrentPage} />
          )}
          {currentPage === 'savedPropertyQuestions' && (
            <SavedPropertyQuestions
              onClose={onModalClose}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Container>
      </Formik>
    </ModalBase>
  )
}

export { SavePropertyModal }
